import { GoogleTagManagerService } from './../../services/analytics/google-tag-manager.service';
import * as moment from 'vendors/moment-locale-th';

import { Component, EventEmitter, Input, OnInit, Output, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';

import $ from 'jquery';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { DialogAlertComponent } from 'app/components/modal/dialog-alert/dialog-alert.component';
import { Router } from '@angular/router';
import { SearchFormModel, GuestModel } from 'app/model/search-form-model';
import { SearchService } from 'app/services/search/search.service';
import { UserService } from 'app/services/user/user.service';
import { UtilitiesService } from 'app/services/utilities/utilities.service';
import { FeatureType, PurposeType, SuggestionCategory } from 'app/model/constant';
import { AuthenticationService } from 'app/services/authentication/authentication.service';
import { DialogSeeAllPropertiesComponent } from '../modal/dialog-see-all-properties/dialog-see-all-properties.component';
import { DecimalPipe } from '@angular/common';
import { Language } from 'app/model/constant';
import { TranslatePipe } from 'app/pipes/translate.pipe';
import { CartService } from 'app/services/cart/cart.service';
import { BudgetAvailableRequest, User } from 'app/model/cart/budget-available.model';
import { DialogConfirmComponent } from '../modal/dialog-confirm/dialog-confirm.component';
import { DialogConfirmType } from '../modal/dialog-confirm/dialog-confirm.model';
import { ProductService } from 'app/services/products/product.service';
import { DialogShareBudgetComponent } from '../modal/dialog-share-budget/dialog-share-budget.component';
import { Booker, ShareBudget } from '../modal/dialog-share-budget/dialog-share-budget.model';
import { DialogShareBudgetDetailComponent } from '../modal/dialog-share-budget/dialog-share-budget-detail/dialog-share-budget-detail.component';
import { AuthorizeService } from 'app/services/authorize/authorize.service';
import { Observable } from 'rxjs/Observable';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { UserFeatureService } from 'app/services/user-feature/user-feature.service';
import { DialogGeneralMessageComponent } from 'app/components/modal/dialog-general-message/dialog-general-message.component';
import * as Cookies from 'js-cookie/src/js.cookie.js';

import { domain, redirectURIV2, useHotelDetailV2, useHotelListV2 } from 'environments/properties';
import { DialogMyProfileActionType } from 'app/pages/my-profile/dialog-my-profile/dialog-my-profile.model';
import { DialogMyProfileComponent } from 'app/pages/my-profile/dialog-my-profile/dialog-my-profile.component';
import { UserInfoModel } from 'app/model/profile/profile.model';

@Component({
  selector: 'app-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.scss']
})
export class SearchBoxComponent implements OnInit, OnChanges {
  @Input() data: any;
  @Input() type: string = 'H'; // H = home, C = Level-C, D = Level-D
  @Input() layout: string = 'home'; // home, topwrap
  @Output('onSubmitSearch') submitSearch = new EventEmitter(); // tslint:disable-line:no-output-rename
  @Output('onGetData') sendData = new EventEmitter(); // tslint:disable-line:no-output-rename
  @Output('onGetState') sendState = new EventEmitter(); // tslint:disable-line:no-output-rename

  @ViewChild('inputDestination') inputDestination;
  @ViewChild('inputCheckIn') inputCheckIn;
  @ViewChild('inputRoomBox') inputRoomBox;

  public searchForm: FormGroup;
  public searchFormModel: SearchFormModel = new SearchFormModel();
  public lastestSearchForm: any;
  private isSelectedDestination: boolean = false;
  private isDestinationFocus: boolean = false;
  private bookWorkPurpose: boolean = true;
  private originId: number;
  private profileData: UserInfoModel;

  public stateDaterangepicker: any;
  public titleDestination: string;
  public searchSubmitted: boolean = false;
  public dateCheckInOutput: string;
  public dateCheckOutOutput: string;

  public user: any;
  public isLimitChild: boolean;
  public isLimitRoom: boolean;
  public isShareBudget = false;
  public displayPermission = true;
  private isAllowOverBudget: boolean = false;
  public isShowRoomBox: boolean = false;
  public isRoomBoxShowArrow: boolean = false;
  public isWorkOnly: boolean = false;
  public isEditable: boolean = false;
  public isSearchHome: boolean = true;
  public isLoading: boolean = false;

  public roomCount: number = 1;
  public adultCount: number = 2;
  public childCount: number = 0;
  public currentTabRoom: number = 1;
  public currentRoom: any;
  private defaultChildrenAges = 12;

  public budget: number;
  public coBudget: number;
  public budgetPerMonth: number;
  public budgetPerYear: number;
  public allowOverBudget: boolean = false;
  public allowCreditTerms: boolean;
  public allowBookForTraveller: boolean;
  public displayFirstLineBudget: string;
  public displaySecondLineBudget: string;
  public lang = Language.th;
  public shareBudget: ShareBudget;

  constructor(
    private formBuilder: FormBuilder,
    private searchService: SearchService,
    private userService: UserService,
    private appConfigService: AppConfigService,
    private router: Router,
    public dialog: MdDialog,
    public utilitiesService: UtilitiesService,
    private authService: AuthenticationService,
    private cartService: CartService,
    private productService: ProductService,
    private decimalPipe: DecimalPipe,
    private translate: TranslatePipe,
    private authorizeService: AuthorizeService,
    private userFeatureService: UserFeatureService,
    private googleTagManagerService: GoogleTagManagerService
  ) {
    let findFeature = this.userService.getUserFeature(FeatureType.ALLOW_LIMIT_CHILD);
    findFeature && (this.isLimitChild = findFeature.allow)
    findFeature = this.userService.getUserFeature(FeatureType.ALLOW_LIMIT_ROOM);
    findFeature && (this.isLimitRoom = findFeature.allow)
    findFeature = this.userService.getUserFeature(FeatureType.ALLOW_SHARE_BUDGET);
    findFeature && (this.isShareBudget = findFeature.allow)

    if (this.userFeatureService.isAllowBudgetLimit()) {
      const limitBudgetFeature = this.userService.getUserFeature(FeatureType.ALLOW_LIMIT_BUDGET);
      this.budget = limitBudgetFeature.data.amount;
      this.coBudget = limitBudgetFeature.data.coBudget;

      this.budgetPerMonth = limitBudgetFeature.data.amountPerMonth;
      this.budgetPerYear = limitBudgetFeature.data.amountPerYear;
      this.allowOverBudget = this.userService.checkAllowToPayOverBudget();
    }
    this.allowCreditTerms = this.userService.getUserFeature(FeatureType.ALLOW_CREDIT_TERMS) && this.userService.getUserFeature(FeatureType.ALLOW_CREDIT_TERMS).allow;
    this.allowBookForTraveller = this.userService.getUserFeature(FeatureType.ALLOW_BOOK_FOR_TRAVELLER) && this.userService.getUserFeature(FeatureType.ALLOW_BOOK_FOR_TRAVELLER).allow;

    this.getCoBooker();
    this.createBudgetText();
    this.bookWorkPurpose = this.userService.getUserFeature(FeatureType.ALLOW_BOOK_WORK_PURPOSE) && this.userService.getUserFeature(FeatureType.ALLOW_BOOK_WORK_PURPOSE).allow != undefined ? this.userService.getUserFeature(FeatureType.ALLOW_BOOK_WORK_PURPOSE).allow : this.bookWorkPurpose;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.getCoBooker();
  }

  ngOnInit() {
    this.lang = this.appConfigService.getLanguage();

    if (!this.data) {
      this.data = {
        checkInDate: moment().format('DD-MM-YYYY'),
        checkOutDate: moment().add(1, 'days').format('DD-MM-YYYY'),
        destination: { title: '', id: '', suggestCat: '', slug: '' },
        guests: [{ adult: 2, children: [] }],
        breakfast: false,
        overBudget: this.allowOverBudget,
        purpose: ''
      };
    } else {
      this.isSelectedDestination = true;
      // this.isSearchHome = false;
    }

    // Setup Data
    this.originId = this.data.destination.id;
    this.searchFormModel.destination = this.data.destination;
    this.searchFormModel.guests = this.data.guests;
    this.searchFormModel.checkInDate = this.utilitiesService.reverseFormatDate(this.data.checkInDate);
    this.searchFormModel.checkOutDate = this.utilitiesService.reverseFormatDate(this.data.checkOutDate);
    this.searchFormModel.purpose = this.isWorkOnly ? 'work' : this.data.purpose;
    this.searchFormModel.breakfast = this.data.breakfast;
    this.searchFormModel.overBudget = this.data.overBudget;
    this.searchFormModel.campaignId = this.data.campaignId;

    this.searchForm = this.formBuilder.group({
      'destination': this.formBuilder.group({
        id: [this.searchFormModel.destination.id],
        title: [this.searchFormModel.destination.title, Validators.required],
        suggestCat: [this.searchFormModel.destination.suggestCat],
        slug: [this.searchFormModel.destination.slug],
        poi: [this.searchFormModel.destination.poi],
        destinationId: [this.searchFormModel.destination.destinationId],
        destinationTitle: [this.searchFormModel.destination.destinationTitle],
        type: [this.searchFormModel.destination.type],
      }),
      'checkInDate': [this.searchFormModel.checkInDate, Validators.required],
      'checkOutDate': [this.searchFormModel.checkOutDate, Validators.required],
      'guests': [this.searchFormModel.guests, Validators.required],
      'purpose': [{ value: this.searchFormModel.purpose, disabled: this.isWorkOnly }, Validators.required],
      'breakfast': [this.searchFormModel.breakfast],
      'overBudget': [this.searchFormModel.overBudget]
    });

    this.currentRoom = this.searchForm.value.guests[0];
    this.lastestSearchForm = JSON.parse(JSON.stringify(this.searchForm.value));
    if (this.isWorkOnly) {
      this.lastestSearchForm.purpose = 'work';
    }
    if (this.isShowLimitedRoomSelect()) {
      this.searchForm.get('guests').setValue([{ adult: this.searchFormModel.guests[0].adult >= 2 ? 2 : 1, children: [] }]);
      // !this.isSearchHome && this.onSubmit({ value: this.searchFormModel, valid: true }, false);
      !this.isSearchHome && this.onSubmit(this.searchFormModel, false);
    }
    this.updateCountOfRoom();
    // call emit data when outside component need data
    this.sendData.emit({ data: this.lastestSearchForm });
    if (this.searchForm.get('destination').get('suggestCat').value == SuggestionCategory.NEAR_BY) {
      this.searchForm.get('destination').get('title').setValue(this.appConfigService.getTranslate('search-box-near-by-you'));
    }
    this.searchForm.controls.destination.valueChanges.subscribe((val) => {
      // do not reset isSelectDestination same value backup of destination.
      if (val.title != this.lastestSearchForm.destination.title
        && val.suggestCat != SuggestionCategory.NEAR_BY) {
        this.isSelectedDestination = false;
      }
    });

    this.searchForm.controls.purpose.valueChanges.subscribe((val) => {
      let config = new MdDialogConfig();
      if (this.isLimitRoom && val == 'work') {
        if (this.roomCount > 1) {
          let dialogRef: MdDialogRef<DialogAlertComponent> = this.dialog.open(DialogAlertComponent, config);
          dialogRef.componentInstance.alertText = this.appConfigService.getTranslate('search-box-error-work-1-room');
          this.resetToRoomDefault();
          this.resetChildren();
        } else if (this.adultCount > 2) {
          let dialogRef: MdDialogRef<DialogAlertComponent> = this.dialog.open(DialogAlertComponent, config);
          dialogRef.componentInstance.alertText = this.appConfigService.getTranslate('search-box-error-work-2-person');
          this.resetToRoomDefault();
          this.resetChildren();
        } else if (this.childCount > 0) {
          let dialogRef: MdDialogRef<DialogAlertComponent> = this.dialog.open(DialogAlertComponent, config);
          dialogRef.componentInstance.alertText = this.appConfigService.getTranslate('search-box-error-work-no-child');
          this.resetToRoomDefault();
          this.resetChildren();
        }
      }

      if (!this.isLimitRoom && val == 'work' && this.childCount > 0) {
        let dialogRef: MdDialogRef<DialogAlertComponent> = this.dialog.open(DialogAlertComponent, config);
        dialogRef.componentInstance.alertText = this.appConfigService.getTranslate('search-box-error-work-no-child');
        this.resetChildren();
      }
    });

    // init date on text read
    this.dateCheckInOutput = this.utilitiesService.getOtaFormatYear(this.lang, this.searchForm.value.checkInDate);
    this.dateCheckOutOutput = this.utilitiesService.getOtaFormatYear(this.lang, this.searchForm.value.checkOutDate);

    this.searchForm.controls.checkInDate.valueChanges.subscribe((val) => { // YYYY-MM-DD
      this.dateCheckInOutput = this.utilitiesService.getOtaFormatYear(this.lang, val);
    });

    this.searchForm.controls.checkOutDate.valueChanges.subscribe((val) => { // YYYY-MM-DD
      this.dateCheckOutOutput = this.utilitiesService.getOtaFormatYear(this.lang, val);
    });

    this.appConfigService.getLanguageObs().subscribe(lang => {
      if (this.searchForm.value.destination.suggestCat == SuggestionCategory.NEAR_BY) {
        this.searchForm.get('destination').get('title').setValue(this.appConfigService.getTranslate('search-box-near-by-you'));

      }
      this.dateCheckInOutput = this.utilitiesService.getOtaFormatYear(lang, this.searchForm.value.checkInDate);
      this.dateCheckOutOutput = this.utilitiesService.getOtaFormatYear(lang, this.searchForm.value.checkOutDate);
      this.lang = lang;
      this.createBudgetText();
    });

    // init class header for can know type search-box from css context
    let $html = $('html');
    $html.removeClass('topwrap-layout home-layout');
    $html.addClass(this.layout + '-layout');

    if (!this.bookWorkPurpose) {
      this.searchForm.get('purpose').setValue(PurposeType.leisure);
    }

    this.authorizeService.getShareBudgetObs().subscribe(res => {
      this.getCoBooker();
      if (res && this.searchForm.value.purpose === PurposeType.work) {
        let suggestCat = this.searchForm.value.destination.suggestCat;
        let params;

        this.searchForm.get('guests').setValue([{ adult: 2, children: [] }]);
        this.lastestSearchForm.guests = [{ adult: 2, children: [] }];
        this.adultCount = 2;
        this.currentRoom.adult = 2;

        if (suggestCat == 'destination' || suggestCat == 'country' || suggestCat === 'pointofinterest') {
          params = {
            destination: this.utilitiesService.encodeQueryParamWrapper(this.searchForm.value.destination),
            purpose: this.isWorkOnly ? 'work' : this.searchForm.value.purpose,
            checkIn: this.utilitiesService.reverseFormatDate(this.searchForm.value.checkInDate),
            checkOut: this.utilitiesService.reverseFormatDate(this.searchForm.value.checkOutDate),
            guests: this.utilitiesService.encodeQueryParamWrapper(this.searchForm.value.guests),
            lang: this.lang
          }
          if (this.isShowPropertiesWithoutBudgetLimit()) {
            params['overBudget'] = this.searchForm.value.overBudget;
          }
        } else if (suggestCat == 'product' || suggestCat == 'hotel') {
          params = {
            destination: this.utilitiesService.encodeQueryParamWrapper(this.searchForm.value.destination),
            purpose: this.isWorkOnly ? 'work' : this.searchForm.value.purpose,
            checkIn: this.utilitiesService.reverseFormatDate(this.searchForm.value.checkInDate),
            checkOut: this.utilitiesService.reverseFormatDate(this.searchForm.value.checkOutDate),
            guests: this.utilitiesService.encodeQueryParamWrapper(this.searchForm.value.guests),
            breakfast: this.searchForm.value.breakfast,
            lang: this.lang
          }
          if (this.isShowPropertiesWithoutBudgetLimit()) {
            params['overBudget'] = this.searchForm.value.overBudget;
          }
        }

        this.router.navigate([], {
          queryParams: params
        });
      }

      if (this.type !== 'H') { // call Emit Event when not is HOME type search-box.
        this.submitSearch.emit({ data: this.lastestSearchForm });
      }
    });
  }

  createBudgetText() {
    const currency = 'THB';
    let budget = '';
    let budgetPerMonth = '';
    let budgetPerYear = '';
    let totalBudget = 0;
    let totalBudgetPerMonth = 0;
    let totalBudgetPerYear = 0;

    if (this.shareBudget) {
      totalBudget = this.shareBudget.totalBudget;
      this.displayPermission = false;
    } else {
      totalBudget = this.budget;
      totalBudgetPerMonth = this.budgetPerMonth;
      totalBudgetPerYear = this.budgetPerYear;
    }

    budget = this.decimalPipe.transform(totalBudget);
    budgetPerMonth = this.decimalPipe.transform(totalBudgetPerMonth);
    budgetPerYear = this.decimalPipe.transform(totalBudgetPerYear);

    let budgetPerNightText = this.shareBudget ? this.translate.transform('search-box-new-budget-per-night') : this.translate.transform('search-box-budget-per-night');
    budgetPerNightText = budgetPerNightText
      .replace(/{currency}/gi, currency)
      .replace(/{budget}/gi, budget);
    const budgetPerMonthText = this.translate.transform('search-box-budget-per-month')
      .replace(/{currency}/gi, currency)
      .replace(/{budgetPerMonth}/gi, budgetPerMonth);
    const budgetPerYearText = this.translate.transform('search-box-budget-per-year')
      .replace(/{currency}/gi, currency)
      .replace(/{budgetPerYear}/gi, budgetPerYear);
    const budgetPerMonthPerYearText = this.translate.transform('search-box-budget-per-month-per-year')
      .replace(/{currency}/gi, currency)
      .replace(/{budgetPerMonth}/gi, budgetPerMonth)
      .replace(/{budgetPerYear}/gi, budgetPerYear);

    if (totalBudget && totalBudgetPerMonth && totalBudgetPerYear) {
      if (this.allowCreditTerms) {
        this.displayFirstLineBudget = budgetPerNightText;
        this.displaySecondLineBudget = budgetPerMonthPerYearText.replace(/<strong>/gi, '').replace(/<\/strong>/gi, '');
      } else {
        this.displayFirstLineBudget = budgetPerNightText;
      }
    } else if (totalBudget && totalBudgetPerMonth && !totalBudgetPerYear) {
      if (this.allowCreditTerms) {
        this.displayFirstLineBudget = budgetPerNightText;
        this.displaySecondLineBudget = budgetPerMonthText.replace(/<strong>/gi, '').replace(/<\/strong>/gi, '');
      } else {
        this.displayFirstLineBudget = budgetPerNightText;
      }
    } else if (totalBudget && !totalBudgetPerMonth && totalBudgetPerYear) {
      if (this.allowCreditTerms) {
        this.displayFirstLineBudget = budgetPerNightText;
        this.displaySecondLineBudget = budgetPerYearText.replace(/<strong>/gi, '').replace(/<\/strong>/gi, '');
      } else {
        this.displayFirstLineBudget = budgetPerNightText;
      }
    } else if (totalBudget && !totalBudgetPerMonth && !totalBudgetPerYear) {
      this.displayFirstLineBudget = budgetPerNightText;
      this.displaySecondLineBudget = null;
    } else if (!totalBudget && totalBudgetPerMonth && totalBudgetPerYear) {
      this.displayFirstLineBudget = budgetPerMonthPerYearText;
      this.displaySecondLineBudget = null;

    } else if (!totalBudget && totalBudgetPerMonth && !totalBudgetPerYear) {
      this.displayFirstLineBudget = budgetPerMonthText;
      this.displaySecondLineBudget = null;

    } else if (!totalBudget && !totalBudgetPerMonth && totalBudgetPerYear) {
      this.displayFirstLineBudget = budgetPerYearText;
      this.displaySecondLineBudget = null;

    } else {
      this.displayFirstLineBudget = this.shareBudget && this.shareBudget.coBooker ? this.translate.transform('search-box-new-budget-unlimited') : this.translate.transform('search-box-budget-unlimited');
      this.displaySecondLineBudget = null;
      this.displayPermission = false;
    }
  }

  onSubmit(value: SearchFormModel, callBudgetAvailable = true) {
    this.searchSubmitted = true;

    if (this.searchForm.value.purpose == '') {
      return false;
    } else if (!this.isSelectedDestination) {
      this.inputDestination.nativeElement.focus();
    } else {
      this.isLoading = true;
      this.allowBookAcrossMonth(value)
        .flatMap((allow) => allow ? Observable.of(allow) : this.showErrorPopupAcrossMonth())
        .flatMap((allowToBook) => {
          if (allowToBook) {
            if (this.allowBookForTraveller) {
              return Observable.of(true);
            }
            return this.checkAvailableBudget(callBudgetAvailable, value);
          }
          return Observable.of(false);
        })
        .flatMap((allowToSearch) => allowToSearch ? this.getCurrentPosition(value) : Observable.of(false))
        .flatMap((allowPosition) => allowPosition ? this.validateUserBirthDateTime() : Observable.of(false))
        .subscribe((res) => {
          if (res) {
            this.navigateToNextPage(value);
          }
          this.isLoading = false;
        }, (err) => {
          this.isLoading = false;
          const dialogRef: MdDialogRef<DialogAlertComponent> = this.dialog.open(DialogAlertComponent);
          dialogRef.componentInstance.alertText = this.appConfigService.getTranslate('system-error');
          dialogRef.afterClosed().subscribe(() => {
            this.utilitiesService.redirectPage('');
          });
        });
    }
  }

  validateUserBirthDateTime(): Observable<boolean> {
    const userCookie = this.userService.getUser();
    this.profileData = new UserInfoModel(userCookie, this.lang);
    if (!this.profileData.birthDate || !this.profileData.timeOfBirth) {
      return this.userService.getuserInfo(userCookie.companyId).flatMap((user) => {
        this.profileData = new UserInfoModel(user, this.lang);
        this.authService.saveUserInformationCookie(user);

        if (!this.profileData.birthDate || !this.profileData.timeOfBirth) {
          return this.openDialogUpdateDateOfBirth();
        }
        return Observable.of(true);
      });
    } else {
      return Observable.of(true);
    }
  }

  openDialogUpdateDateOfBirth(): Observable<boolean> {
    return this.dialog.open(DialogMyProfileComponent, {
      data: {
        profileData: this.profileData,
        title: 'positive-energy-title',
        subTitle: 'positive-energy-title-desc',
        submitText: 'positive-energy-btn-submit',
        applyMuTravel: true,
      },
    }).afterClosed().map((val: { action: DialogMyProfileActionType, data: any }) => {
      switch (val.action) {
        case DialogMyProfileActionType.UPDATED:
          return true;
        case DialogMyProfileActionType.CANCEL:
          this.isLoading = false;
          return false;
      }
    });
  }

  getCurrentPosition(value: SearchFormModel): Observable<boolean> {
    if (value.destination.suggestCat === SuggestionCategory.NEAR_BY) {
      if (navigator.geolocation) {
        const options = {
          enableHighAccuracy: false,
          timeout: 2000,
          maximumAge: 0,
        };

        return new Observable<boolean>((observer) => {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              value.destination.title = this.appConfigService.getTranslate('search-box-near-by-you');
              value.destination.poi = {
                lat: position.coords.latitude,
                lon: position.coords.longitude,
              };
              Cookies.set(AppConfigService.lat, position.coords.latitude.toString(), { domain: domain });
              Cookies.set(AppConfigService.lon, position.coords.longitude.toString(), { domain: domain });
              observer.next(true);
              observer.complete();
            },
            (error) => {
              this.displayPopup();
              this.isLoading = false;
              observer.next(false);
              observer.complete();
            },
            options
          );
        });
      } else {
        return Observable.of(false);
      }
    } else {
      return Observable.of(true);
    }
  }

  checkAvailableBudget(callBudgetAvailable: boolean, searchForm: SearchFormModel): Observable<boolean> {
    if (callBudgetAvailable && searchForm.purpose === PurposeType.work) {
      return this.authService.getUserFeature(null, this.userService.getUser(), [FeatureType.ALLOW_LIMIT_BUDGET, FeatureType.ALLOW_CREDIT_TERMS])
        .flatMap((feature) => {
          const limitBudgetFeature = feature && feature.length > 0 ? feature.find(f => f.feature === FeatureType.ALLOW_LIMIT_BUDGET) : undefined;
          const allowCreditTerms = feature && feature.length > 0 ? feature.find(f => f.feature === FeatureType.ALLOW_CREDIT_TERMS) : undefined;
          const hasBudgetPerMonthOrYear = limitBudgetFeature && limitBudgetFeature.allow && limitBudgetFeature.data
            && (limitBudgetFeature.data.amountPerMonth || limitBudgetFeature.data.amountPerYear);
          const shareBudgetCode = this.authorizeService.getShareBudgetCodeCookie();

          if (allowCreditTerms && allowCreditTerms.allow && (hasBudgetPerMonthOrYear || shareBudgetCode)) {
            const request = new BudgetAvailableRequest();
            request.checkIn = searchForm.checkInDate;
            request.checkOut = searchForm.checkOutDate;
            request.companyId = this.userService.getUser().companyId;
            request.lang = this.appConfigService.getLanguage();
            request.page = 'search';
            request.shareBudgetCode = shareBudgetCode;
            return this.cartService.getBudgetAvailable(request)
              .flatMap((res: any) => {
                if (res && res.errors && res.errors.length > 0 && res.errors[0].code) {
                  return this.handlePopupAvailableBudget(res.errors[0]);
                } else {
                  return Observable.of(true);
                }
              }).catch((err) => {
                let observer: Observable<boolean>;
                if (err && err.json() && err.json().errors && err.json().errors.length > 0) {
                  const errors = err.json().errors;
                  let dialogMessage;
                  let systemError: boolean;
                  switch (errors[0].code) {
                    case '4701':
                      dialogMessage = {
                        text: this.translate.transform('dialog-budget-cannot-share-budget-co-booker'),
                        subText: this.translate.transform('search-box-error-code-ref-incorrect')
                      };
                      break;
                    case '4702':
                      dialogMessage = {
                        text: this.translate.transform('dialog-budget-cannot-share-budget-co-booker'),
                        subText: this.translate.transform('search-box-error-code-ref-expired')
                      };
                      break;
                    case '4704':
                    case '4705':
                      dialogMessage = {
                        text: this.translate.transform('dialog-budget-cannot-share-budget-co-booker'),
                        subText: this.translate.transform('search-box-error-feature-not-allow')
                      };
                      break;
                    default:
                      systemError = true;
                      const dialogAlertRef: MdDialogRef<DialogAlertComponent> = this.dialog.open(DialogAlertComponent);
                      dialogAlertRef.componentInstance.alertText = this.appConfigService.getTranslate('system-error');
                      dialogAlertRef.componentInstance.imageSrc = '/assets/images/icons/icon-failed.png';
                      dialogAlertRef.componentInstance.imageSrcSet = '/assets/images/icons/icon-failed.png';
                      break;
                  }

                  if (systemError) {
                    return Observable.of(false);
                  } else {
                    const dialogRef: MdDialogRef<DialogConfirmComponent> = this.dialog.open(DialogConfirmComponent, {
                      data: {
                        confirmType: DialogConfirmType.CONFIRM_CONTINUE_BOOKER_BUDGET,
                        data: { message: dialogMessage }
                      }
                    });

                    return dialogRef.afterClosed().flatMap(m => {
                      this.cancelShareBudget();
                      if (m) {
                        if (errors[0].code === '4704') {
                          this.authorizeService.setCookieFeatureShareBudgetIsFalse();
                        }
                        return Observable.of(true);
                      } else {
                        // Reload current router
                        this.router.routeReuseStrategy.shouldReuseRoute = function () {
                          return false;
                        };
                        this.router.navigated = false;
                        this.router.navigateByUrl(this.router.url);
                        return Observable.of(false);
                      }
                    });
                  }
                }
                return observer;
              });
          }
          return Observable.of(true);
        });
    }
    return Observable.of(true);
  }

  handlePopupAvailableBudget(error: { code: string, message: string }): Observable<boolean> {
    const allowMultiPayment = this.productService.allowMultiPayment(this.userService.getUser());
    const text = error.message;

    let dialogConfirmType: DialogConfirmType;
    let dialogMessage: { text: string, subText: string };
    this.getCoBooker();

    switch (error.code) {
      case '2004':
        if (this.shareBudget) {
          dialogMessage = {
            text: this.translate.transform('dialog-budget-cannot-share-budget-co-booker'),
            subText: this.lang === Language.en ? this.translate.transform('dialog-budget-due-to') + text : text
          };
          dialogConfirmType = DialogConfirmType.CONFIRM_CANCEL_SHARE_BUDGET;
        } else {
          dialogMessage = {
            text: text.charAt(0).toUpperCase() + text.slice(1),
            subText: this.translate.transform('dialog-budget-pay-option')
          };
          dialogConfirmType = DialogConfirmType.CONFIRM_AVAILABLE_BUDGET;
        }
        break;
      case '2005':
        if (this.shareBudget) {
          dialogMessage = {
            text: this.translate.transform('dialog-budget-cannot-share-budget-co-booker'),
            subText: this.lang === Language.en ? this.translate.transform('dialog-budget-due-to') + text : text
          };
          dialogConfirmType = DialogConfirmType.CONFIRM_CONTINUE_BOOKER_BUDGET;
        } else {
          if (allowMultiPayment) {
            dialogMessage = {
              text: text.charAt(0).toUpperCase() + text.slice(1),
              subText: this.translate.transform('dialog-budget-pay-exceeding-option')
            };
          } else {
            dialogMessage = {
              text: text.charAt(0).toUpperCase() + text.slice(1),
              subText: this.translate.transform('dialog-budget-pay-option')
            };
          }
          dialogConfirmType = DialogConfirmType.CONFIRM_AVAILABLE_BUDGET;
        }
        break;
      case '2006':
        if (!allowMultiPayment) {
          dialogMessage = {
            text: this.translate.transform('dialog-budget-cannot-share-budget-co-booker'),
            subText: this.lang === Language.en ? this.translate.transform('dialog-budget-due-to') + text : text
          };
          dialogConfirmType = DialogConfirmType.CONFIRM_CANCEL_SHARE_BUDGET;
        }
      case '2007':
        if (!allowMultiPayment) {
          dialogMessage = {
            text: this.translate.transform('dialog-budget-cannot-share-budget-co-booker'),
            subText: this.lang === Language.en ? this.translate.transform('dialog-budget-due-to') + text : text
          };
          dialogConfirmType = DialogConfirmType.CONFIRM_CONTINUE_BOOKER_BUDGET;
        }
        break;
    }

    if (dialogMessage) {
      const dialogRef: MdDialogRef<DialogConfirmComponent> = this.dialog.open(DialogConfirmComponent, {
        data: {
          confirmType: dialogConfirmType,
          data: { message: dialogMessage }
        }
      });
      return dialogRef.afterClosed().map((res) => {
        let redirect = false;
        if (res) {
          switch (dialogConfirmType) {
            case DialogConfirmType.CONFIRM_CANCEL_SHARE_BUDGET:
              this.cancelShareBudget();
              redirect = this.type === 'C' || this.type === 'D';
              break;
            case DialogConfirmType.CONFIRM_CONTINUE_BOOKER_BUDGET:
              this.cancelShareBudget();
              redirect = true;
              break;
            default:
              redirect = true;
              break;
          }
        }
        return redirect;
      });
    } else {
      return Observable.of(true);
    }
  }

  navigateToNextPage(value: SearchFormModel) {
    // can submit and call emit event
    // alert('Goto LevelC: "' + value.destination + '"');
    let suggestCat = this.searchForm.value.destination.suggestCat;

    this.googleTagManagerService.emitEvent('Search', suggestCat, this.searchForm.value.destination.title, 1, this.searchForm.value.destination.title);

    let slug = suggestCat === 'pointofinterest' ? '' : this.searchForm.value.destination.slug;

    slug = this.utilitiesService.resolveSlugSpace(slug);

    if (this.isNavigateToProductDetail(suggestCat)) {
      delete this.searchForm.value.destination.destinationId;
      delete this.searchForm.value.destination.destinationTitle;

      const params = {
        destination: this.utilitiesService.encodeQueryParamWrapper(this.searchForm.value.destination, useHotelDetailV2),
        purpose: this.isWorkOnly ? 'work' : this.searchForm.value.purpose,
        checkIn: this.utilitiesService.reverseFormatDate(this.searchForm.value.checkInDate),
        checkOut: this.utilitiesService.reverseFormatDate(this.searchForm.value.checkOutDate),
        guests: this.utilitiesService.encodeQueryParamWrapper(this.searchForm.value.guests, useHotelDetailV2),
        breakfast: this.searchForm.value.breakfast,
        lang: this.lang
      }
      if (this.isShowPropertiesWithoutBudgetLimit()) {
        params['overBudget'] = this.searchForm.value.overBudget;
      }
      if (this.searchFormModel.campaignId) {
        params['campaignId'] = this.searchFormModel.campaignId;
      }

      if (useHotelDetailV2) {
        window.location.href = `${redirectURIV2}/hotel/${slug}${this.utilitiesService.objectToQueryString(params)}`;
      } else {
        this.router.navigate(
          ['hotel/detail/' + slug], {
          queryParams: params
        }
        ).then((res) => {
          this.originId = this.searchForm.value.destination.id;
          if (this.type !== 'H') { // call Emit Event when not is HOME type search-box.
            this.submitSearch.emit({ data: value });
            this.hideEditable();
          }
        });
      }
    } else {

      if (suggestCat == 'product') {
        this.searchForm.value.destination.title = this.searchForm.value.destination.destinationTitle;
      }

      const params = {
        destination: this.utilitiesService.encodeQueryParamWrapper(this.searchForm.value.destination),
        purpose: this.isWorkOnly ? 'work' : this.searchForm.value.purpose,
        checkIn: this.utilitiesService.reverseFormatDate(this.searchForm.value.checkInDate),
        checkOut: this.utilitiesService.reverseFormatDate(this.searchForm.value.checkOutDate),
        guests: this.utilitiesService.encodeQueryParamWrapper(this.searchForm.value.guests),
        lang: this.lang
      }
      if (this.isShowPropertiesWithoutBudgetLimit()) {
        params['overBudget'] = this.searchForm.value.overBudget;
      }

      if (useHotelListV2) {
        window.location.href = `${redirectURIV2}/hotel/searchdestination${this.utilitiesService.objectToQueryString(params)}`;
      } else {
        this.router.navigate(
          ['hotel/searchdestination'], {
          queryParams: params
        }
        ).then((res) => {
          this.originId = this.searchForm.value.destination.id;
          if (this.type !== 'H') { // call Emit Event when not is HOME type search-box.
            this.submitSearch.emit({ data: value });
            this.hideEditable();
          }
        });
      }
    }

    this.lastestSearchForm = value;
    if (this.isWorkOnly) {
      this.lastestSearchForm.purpose = 'work';
    }
  }

  isNavigateToProductDetail(suggestCat: string) {
    let isNavigateToProductDetail = false;
    if (suggestCat == 'product'
      && (this.searchForm.value.destination.type == 'history'
        || (this.type == 'D' && this.originId == this.searchForm.value.destination.id))) {
      isNavigateToProductDetail = true;
    }

    return isNavigateToProductDetail;
  }

  getCoBooker() {
    const coBookerCookie = this.authorizeService.getCoBookerCookie();
    if (coBookerCookie) {
      this.shareBudget = new ShareBudget();
      this.shareBudget.booker = new Booker(this.userService.getUser().userId, this.userService.getUser().companyId, this.userService.getUser().email, this.budget);
      this.shareBudget.coBooker = new Booker(coBookerCookie.userId, coBookerCookie.companyId, coBookerCookie.email, coBookerCookie.amount);
      this.setTotalBudget();
    } else {
      this.shareBudget = undefined;
      this.authorizeService.removeCoBookerCookie();
    }
  }

  allowBookAcrossMonth(searchForm: SearchFormModel): Observable<boolean> {
    let requestTasks = [this.authService.getUserFeature(null, this.userService.getUser(), [FeatureType.ALLOW_BOOK_ACROSS_MONTHS])];

    if (this.shareBudget) {
      const shareBudgetCode = this.authorizeService.getShareBudgetCodeCookie();
      requestTasks.push(this.authService.getUserFeature(null, this.userService.getUser(), [FeatureType.ALLOW_BOOK_ACROSS_MONTHS], false, shareBudgetCode));
    }

    const dateFormat = 'YYYY-MM-DD';
    const checkIn = moment(searchForm.checkInDate, dateFormat);
    const checkOut = moment(searchForm.checkOutDate, dateFormat);
    const firstDayOfMonth = moment(searchForm.checkOutDate, dateFormat).startOf('month');

    if (searchForm.purpose === 'work'
      && this.inputDestination !== undefined
      && !checkIn.isSame(checkOut, 'month')
      && !checkOut.isSame(firstDayOfMonth, 'day')) {
      return forkJoin(requestTasks).map((results: any) => {
        const [booker, coBooker] = results;
        let allow = true;
        if (booker && booker.length > 0) {
          allow = allow && booker[0].allow;
        }

        if (coBooker && coBooker.length > 0) {
          allow = allow && coBooker[0].allow;
        }

        return allow;
      });
    }
    return Observable.of(true);
  }

  showErrorPopupAcrossMonth() {
    const config = new MdDialogConfig();
    const dialogRef: MdDialogRef<DialogAlertComponent> = this.dialog.open(DialogAlertComponent, config);
    dialogRef.componentInstance.alertText = this.shareBudget ? this.appConfigService.getTranslate('productlists-pop-up-error-across-month-share-budget') : this.appConfigService.getTranslate('productlists-pop-up-error-across-month');
    dialogRef.componentInstance.imageSrc = '/assets/images/icons/icon-calendar.png';
    dialogRef.componentInstance.imageSrcSet = '/assets/images/icons/icon-calendar.png';
    return dialogRef.afterClosed().map(() => false);
  }

  isShowLimitedRoomSelect() {
    return this.searchForm.value.purpose == 'work' && (this.isLimitRoom || this.shareBudget);
  }

  isShowFreeStyleRoomSelect() {
    return this.searchForm.value.purpose == 'leisure' || (!this.isLimitRoom && !this.shareBudget) && this.searchForm.value.purpose != '';
  }

  isShowPropertiesWithoutBudgetLimit() {
    return this.searchForm.value.purpose == 'work' && this.allowOverBudget && this.budget;
  }

  toggleRoomBox(event: any) {
    if (this.isShowRoomBox) {
      this.hideRoomBox(event);
    } else {
      this.showRoomBox(event);
    }
  }

  showRoomBox(event: any) {
    this.isShowRoomBox = true;

    // Oganize JS Queue Stack Process.
    setTimeout(() => {
      $('html').on('click.hideRoomBox', (e) => {
        this.hideRoomBox(e);
      });
      this.detectToShowArrow();
    });
  }

  hideRoomBox(event: any) {
    this.isShowRoomBox = false;
    $('html').off('click.hideRoomBox');
  }

  stopPropagation(event: any) {
    event.stopPropagation();
  }

  handleOnFocusDestination() {
    this.isDestinationFocus = true;
  }

  handleOnBlurDestination() {
    this.isDestinationFocus = false;
  }

  displayPopup() {
    const message = {
      title: this.appConfigService.getTranslate('location-not-found'),
      message: this.appConfigService.getTranslate('location-message-not-found'),
      mainBtn: this.appConfigService.getTranslate('enter')
    };
    const config = {
      hasBackdrop: true,
      disableClose: false,
      focusOnOpen: false,
      data: message
    };
    const dialogRef: MdDialogRef<DialogGeneralMessageComponent> = this.dialog.open(DialogGeneralMessageComponent, config);
    dialogRef.afterClosed().subscribe(state => {
      this.inputDestination.nativeElement.blur();
    })
    dialogRef.componentInstance.img = '/assets/images/icons/product-list-search-not-found.png';
  }

  handleOnSelectedDestination(event: any) {
    // Emit Set Selected Item from TypeAhead AutoSuggestion
    this.isSelectedDestination = true;
  }

  resetDestinationValue(event: Event) {
    this.searchForm.controls.destination.setValue({ title: '', id: '', suggestCat: '', slug: '', poi: null, destinationId: null, destinationTitle: null, type: null });
    this.isSelectedDestination = false;
  }

  resetToRoomDefault() {
    this.setActiveTabRoom(1);
    this.searchForm.controls.guests.setValue([{ adult: 2, children: [] }]);
    this.currentRoom = this.searchForm.value.guests[0];
    this.roomCount = 1;
    this.adultCount = 2;
  }


  // RoomBox
  handlerOnChangeRoom(event: any) {
    let oldRoomCount = this.roomCount;
    let roomChoose = parseInt(event.target.value);
    let _rooms = this.searchForm.value.guests;

    if (oldRoomCount > roomChoose) {
      // delete room
      _rooms.splice(roomChoose);
      this.setActiveTabRoom(roomChoose);
    } else {
      // add room
      let newRoomsCount = roomChoose - oldRoomCount;
      let newRooms = [];
      for (let i = 0; i < newRoomsCount; i++) {
        newRooms.push({
          adult: 2,
          children: []
        });
      }

      this.searchForm.controls.guests.setValue(_rooms.concat(newRooms));
    }
    this.roomCount = roomChoose;
    this.updateCountOfRoom();
    this.detectToShowArrow();
  }

  handlerOnChangeAdultCount(event: any) {
    let _adultCount = parseInt(event.target.value);
    this.currentRoom.adult = _adultCount;

    if (this.isShowLimitedRoomSelect()) {
      this.searchForm.get('guests').setValue([{ adult: _adultCount, children: [] }]);
    }

    this.updateCountOfRoom();
  }

  handlerOnChangeChildren(event: any) {
    let oldChildrenCount = this.currentRoom.children.length;
    let _childrenCount = parseInt(event.target.value);

    if (oldChildrenCount > _childrenCount) {
      // delete children
      this.currentRoom.children.splice(_childrenCount);
    } else {
      // add children
      let newChildrenCount = _childrenCount - oldChildrenCount;
      let newChildren = [];
      for (let i = 0; i < newChildrenCount; i++) {
        newChildren.push(this.defaultChildrenAges);
      }
      this.currentRoom.children = this.currentRoom.children.concat(newChildren);
    }

    let guests = [];
    this.searchForm.value.guests.forEach((guest, index) => {
      guests.push(this.currentTabRoom - 1 == index ? this.currentRoom : guest);
    });
    this.searchForm.get('guests').setValue(guests);
    this.updateCountOfRoom();
  }

  handlerOnChangeChildrenOld(event: any, i) {
    this.currentRoom.children[i] = parseInt(event.target.value);
  }

  resetChildren() {
    let _rooms = this.searchForm.value.guests;
    _rooms.forEach((room) => {
      room.children = [];
    });
    this.childCount = 0;
    this.searchForm.controls.guests.setValue(_rooms);
  }

  setActiveTabRoom(index) {
    if (this.currentTabRoom != index) {
      this.currentTabRoom = index;
      this.currentRoom = this.searchForm.value.guests[index - 1];
      this.moveScrollToItem();
    }
  }

  nextActiveTabRoom() {
    let nextRoom = this.currentTabRoom < this.searchForm.value.guests.length ? this.currentTabRoom + 1 : this.currentTabRoom;
    this.setActiveTabRoom(nextRoom);
    this.moveScrollToItem();
  }

  prevActiveTabRoom() {
    let prevRoom = this.currentTabRoom > 1 ? this.currentTabRoom - 1 : 1;
    this.setActiveTabRoom(prevRoom);
    this.moveScrollToItem();
  }

  detectToShowArrow() {
    let $tabContainer = $('.select-room-popup-container');
    let $scrollContainer = $tabContainer.find('.tab-detail-room-list ul');
    let $tabs = $tabContainer.find('li');
    let $currentTab = $tabs[this.currentTabRoom - 1];

    let tabWidth = $currentTab.clientWidth;
    let scrollContainerWidth = $scrollContainer[0].clientWidth;
    let scrollLeft = $scrollContainer[0].scrollLeft;
    let currentPosLeft = $($currentTab).position().left;
    let currentPosRight = currentPosLeft + tabWidth;

    // detect item is width over range
    if ((tabWidth + 2) * this.roomCount > scrollContainerWidth) {
      this.isRoomBoxShowArrow = true;
    } else {
      this.isRoomBoxShowArrow = false;
    }
  }

  moveScrollToItem() {
    let $tabContainer = $('.select-room-popup-container');
    let $scrollContainer = $tabContainer.find('.tab-detail-room-list ul');
    let $tabs = $tabContainer.find('li');
    let $currentTab = $tabs[this.currentTabRoom - 1];

    let tabWidth = $currentTab.clientWidth;
    let scrollContainerWidth = $scrollContainer[0].clientWidth;
    let scrollLeft = $scrollContainer[0].scrollLeft;
    let currentPosLeft = $($currentTab).position().left;
    let currentPosRight = currentPosLeft + tabWidth;

    // detect visible tab on scroll
    let targetLeftPos = (tabWidth + 2) * (this.currentTabRoom - 1);
    if (currentPosRight > scrollContainerWidth) {
      $scrollContainer[0].scrollLeft = targetLeftPos - scrollContainerWidth + tabWidth + 30;
    } else if (currentPosLeft < 0) {
      $scrollContainer[0].scrollLeft = targetLeftPos - 30;
    }
  }

  updateCountOfRoom() {
    let _adultCount = 0;
    let _childCount = 0;
    this.searchForm.value.guests.forEach((room, i) => {
      _adultCount += room.adult;
      _childCount += room.children.length;
    });
    this.roomCount = this.searchForm.value.guests.length;
    this.adultCount = _adultCount;
    this.childCount = _childCount;
  }

  trackByChild(index: number, child): number {
    return index;
  }

  // top wrap layout
  showEditable() {
    this.isEditable = true;
    this.sendState.emit({ mode: 'EDIT' });
  }
  hideEditable() {
    this.isEditable = false;
    this.sendState.emit({ mode: 'NORMAL' });
  }
  cancleChangeSearch() {
    this.hideEditable();
    if (this.lastestSearchForm.destination.suggestCat == SuggestionCategory.NEAR_BY) {
      this.lastestSearchForm.destination.title = this.appConfigService.getTranslate('search-box-near-by-you');
    }
    this.searchForm.reset(JSON.parse(JSON.stringify(this.lastestSearchForm)));
    this.isSelectedDestination = true;
    this.currentRoom = this.searchForm.value.guests[0];
    this.updateCountOfRoom();
  }

  handleClickDestinationTextArea() {
    this.showEditable();
    if (!window.matchMedia('(max-width: 767px)').matches) {
      setTimeout(() => {
        this.inputDestination && this.inputDestination.nativeElement.focus();
      }, 600);
    } else {
      setTimeout(() => {
        this.inputDestination.nativeElement.focus();
      }, 800);
    }
  }
  handleClickDateTextArea() {
    this.showEditable();
    setTimeout(() => {
      if (this.utilitiesService.isIOS()) {
        $(this.inputCheckIn.nativeElement).trigger('touchend');
      } else {
        $(this.inputCheckIn.nativeElement).trigger('click');
      }
    }, 400);
  }
  handleClickRoomTextArea() {
    this.showEditable();
    setTimeout(() => {
      if (this.inputRoomBox) {
        $(this.inputRoomBox.nativeElement).trigger('click');
      }
    }, 200);
  }

  public openDialogTooltips() {
    const isClickable = window.matchMedia('(max-width: 767px)').matches;
    isClickable && this.dialog.open(DialogSeeAllPropertiesComponent);
  }

  openDialogShareBudget() {
    const dialogRef: MdDialogRef<DialogShareBudgetComponent> = this.dialog.open(DialogShareBudgetComponent);
    dialogRef.afterClosed().subscribe((val: { event: string, shareBudget: ShareBudget }) => {

      if (val.event === 'success') {
        this.shareBudget = val.shareBudget;
        this.shareBudget.booker = new Booker(this.userService.getUser().userId, this.userService.getUser().companyId, this.userService.getUser().email, this.budget);
        this.setTotalBudget();
        this.authorizeService.setShareBudgetObs(true);
        this.handlerOnChangeAdultCount({ target: { value: 2 } });
        this.createBudgetText();
      }

      if (val.event === 'closeDialog') {
        dialogRef.close();
      }

      if (val.event === 'close') {
        dialogRef.close();
        const dialog = this.dialog.open(DialogConfirmComponent, { data: { confirmType: DialogConfirmType.CONFIRM_CLOSE } });
        dialog.afterClosed().subscribe(res => {
          if (!res) {
            this.openDialogShareBudget();
          }
        });
      }

      if (val.event === 'bookerNotAllowFeature') {
        // Reload current router
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.navigated = false;
        this.router.navigateByUrl(this.router.url);
      }
    });
  }

  openDialogShareBudgetDetail() {
    const dialogRef: MdDialogRef<DialogShareBudgetDetailComponent> = this.dialog.open(DialogShareBudgetDetailComponent, {
      data: this.shareBudget
    });
  }

  onCancelShareBudget() {
    const message = { text: this.translate.transform('dialog-cancel-share-budget-text'), subText: this.translate.transform('dialog-cancel-share-budget-sub-text') };
    const dialogRef: MdDialogRef<DialogConfirmComponent> = this.dialog.open(DialogConfirmComponent,
      {
        data: {
          confirmType: DialogConfirmType.CONFIRM_CANCEL_SHARE_BUDGET_FROM_USER,
          data: {
            message: message
          }
        },
      });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.cancelShareBudget();
      }
    });
  }

  cancelShareBudget() {
    this.shareBudget = undefined;
    this.authorizeService.removeCoBookerCookie();
    this.authorizeService.setShareBudgetObs(false);
    this.createBudgetText();
  }

  updateRoomAndGuestRequest(guests: GuestModel[]): SearchFormModel {
    // Reload search result when room and guest changed
    // (for FIT and Agoda hotel or hotel crossCondition = false)
    this.searchFormModel.guests = guests;
    this.searchForm.get('guests').setValue(guests);
    this.currentRoom = this.searchForm.value.guests[0];
    this.lastestSearchForm = JSON.parse(JSON.stringify(this.searchForm.value));
    this.updateCountOfRoom();
    return this.searchFormModel;
  }

  setTotalBudget() {
    this.shareBudget.totalBudget = this.shareBudget.booker.amount + this.shareBudget.coBooker.amount;
    this.shareBudget.applyCoBudget = false;
    if (this.coBudget) {
      if (!this.shareBudget.totalBudget || this.shareBudget.totalBudget > this.coBudget) {
        this.shareBudget.totalBudget = this.coBudget;
        this.shareBudget.applyCoBudget = true;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/search-box/search-box.component.ts